import { styled, Box } from '@mui/material';

export const RowContainer = styled(Box)(({ theme }) => ({
  width: '50%',
  marginTop: theme.spacing(2),
}));
